const menuEn = {
    "add_to_cart": "Add to cart",
    "add_to_order": "Add to order",
    "already_in_cart": "Already in your cart",
    "update_order_item": "Update order",
    "delete_order_item": "Remove item",
    "available_categories": "Menu categories",
    "search_menu_placeholder": "Search in the menu",
    "guides": {
        "scan_qr": "Scan the QR code on the table with your phone",
        "order": "Order the selected items from your phone",
        "pay": "Pay separately or all at once from your phone",
        "accept": "Continue",
    },
    "index_image": "Index image",
    "menu_saved": "Menu saved",
    "new_category": "New category",
    "menu_editor": "Menu editor",
    "new_item": "New item",
    "menu": "Menu",
    "allergens": "Allergens",
    "generate_qr": "Generate QR code",
    "allergen_list": {
        "gluten": "Gluten",
        "crustaceans": "Crustaceans",
        "eggs": "Eggs",
        "fish": "Fish",
        "peanuts": "Peanuts",
        "soybeans": "Soybeans",
        "milk": "Milk",
        "nuts": "Nuts",
        "celery": "Celery",
        "mustard": "Mustard",
        "sesame": "Sesame",
        "sulphur_dioxide": "Sulphur dioxide",
        "lupin": "Lupin",
        "molluscs": "Molluscs",
        "vegan": "Vegan"
    },
    "add_allergen": "Add allergen",
    "auto_translate": "Menu translation",
    "no_category_name": "No category name specified in the current language",
    "no_item_name": "No item name specified in the current language",
    "category_and_items_language": "Category and items language",
    "auto_translate_title": "Automatic menu translation can only be applied to categories and items that have already been saved. It is recommended to fill in the initial language.",
    "auto_translate_description": "This feature uses Google Translate. The translations are not always accurate, so it is worth checking them.",
    "translate_from": "Translate from",
    "translate_to": "To these languages",
    "auto_translate_error_invalid_languages": "Invalid languages selected for translation",
    "auto_translate_success": "Menu successfully translated",
    "auto_translate_error_permission": "You do not have permission to translate the menu",
    "auto_translate_error_generic": "An unknown error occurred during translation",
    "auto_translate_feature_not_available": "Automatic menu translation is only available with a PRO subscription.",
    "change_subscription_plan": "Change subscription plan",

    "menu_headers": "Menu headers and footers",
    "menu_header_editor_title": "Menu headers and footers are the texts that appear at the top and bottom of your online menu, which you can freely specify.",
    "menu_header_feature_not_available": "Editing the menu header and footer is only available with a PRO subscription.",
    "menu_header": "Menu header",
    "menu_header_placeholder": "Write a short welcome message or highlight a current offer",
    "menu_footer": "Menu footer",
    "menu_footer_placeholder": "You can enter information about service charges, allergens or other important information",
    "menu_header_save_success": "Menu header and footer saved successfully",
    "menu_header_save_error": "An error occurred while saving the menu header and footer",
    "menu_header_permission_error": "You do not have permission to edit the menu header and footer to edit footer",
    "menu_header_generic_error": "An unknown error occurred while loading the menu header and footer",

    "menu_import": "Menu import",
    "import_success": "The last import was successfully completed",
    "import_failed": "The last import failed because of a server side export",
    "attached_document": "Attached document",
    "allowed_file_types": "Allowed file types: .doc, .docx, .pdf, .txt, .html",
    "import_language_helpertext": "Document language",
    "import_options_pro_helpertext": "The 'Deactivate' and 'Add' options are only available with a PRO subscription.",
    "import_option_helpertexts": {
        "replace": "The current menu categories and items will be deleted and replaced with the newly generated menu.",
        "deactivate": "The current menu categories and items will be deactivated, and the newly generated menu will be added.",
        "add": "The current menu will remain, and the new menu items will be appended after the current menu.",
    },
    "import_type": "Import type",
    "import_options": {
        "replace": "Replace",
        "deactivate": "Deactivate",
        "add": "Add",
    },
    "menu_import_tooltip": "Upload a file containing your restaurant's menu or provide a link to a website containing the menu. In both cases, make sure that the menu is textually available in the document, as we cannot process images. After starting the import, our AI will automatically process the file and create the new menu in the selected language. If you want to translate the items into multiple languages later, use the 'Menu Translation' feature! The import process takes 5 - 10 minutes.",
    "menu_import_replace_warning": "A jelenleg kiválasztott importálási mód törölni fogja a jelenlegi menüt és kicseréli az új menüre. Kérlek győzödj meg róla, hogy a feltöltött fájl megfelelő formátumú és tartalmú, mert a művelet visszafordíthatatlan! Ha nem szeretnéd törölni a jelenlegi menüt, kérlek válassz másik importálási módot.",
    "start_import": "Import",
    "file_or_url_required": "Please select a file or provide a website URL",
    "file_and_url_error": "You can only provide either a file or a URL, not both",
    "import_site_url": "Website URL",
    "import_in_progress": "Import in progress",
    "import_duration": "This may take a few minutes",
    "listing_manager_info": {
        "summary": "With Mozrest, you can easily manage your listings and reviews from a single platform. Save time, improve your online reputation, and increase operational efficiency.",
        "bullet_1": "Instantly update your listings on Tripadvisor, Apple Maps, Google, Facebook, Quandoo, and Bing with just one click.",
        "bullet_2": "Get real-time notifications when your hours and availability don't match, preventing guest disappointment and negative reviews.",
        "bullet_3": "Quickly check your listing for completeness to ensure all important details—like photos, menus, and hours—are accurate and up-to-date.",
        "setup_button": "Set up Mozrest",
        "pro_warning": "This feature requires a PRO subscription."
    },
    "listing_manager_tabs": {
        "Listing": "Listing",
        "ListingAnalytics": "Listing Analytics",
        "ReviewsPage": "Reviews",
        "ReviewAnalytics": "Review Analytics",
        "ReplyTemplates": "Reply Templates",
        "Notifications": "Notifications"
    },
    "review_manager_set_title": "Set up review manager",
    "review_manager_set_description": "Please provide some information about your business so we can create your basic settings",
    "confirm_settings": "Confirm settings",
}

export default menuEn;